import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { GenerateInvoiceSuccessModalComponent } from '../generate-invoice-success-modal/generate-invoice-success-modal.component';
import { AuthenticationService } from 'src/app/shared/services';

@Component({
  selector: 'app-attach-invoice-modal',
  templateUrl: './attach-invoice-modal.component.html',
  styleUrls: ['./attach-invoice-modal.component.scss'],
})
export class AttachInvoiceModalComponent implements OnInit {
  sendButton = false;
  boobleModalData: InboundOrderDto;
  invoiceFile: File;
  loading: boolean;
  private readonly notifier: NotifierService;

  readonly lastModified: number;
  readonly name: string;
  isMobile = false;
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    notifierService: NotifierService,
    private modalService: BoobleModalService,
    private readonly accountService: AuthenticationService,
    private readonly ordersService: OrdersService
  ) {
    this.notifier = notifierService;
  }

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 820 ? true : false;
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  async uploadDocumentsFile(event: any) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    if (fileList) {
      this.invoiceFile = fileList.item(0);
      this.sendButton = true;
    }
  }

  openGenerateSuccessModal() {
    this.loading = true;

    this.ordersService
      .uploadReceiptFileOutbound(
        this.boobleModalData.id,
        this.invoiceFile,
        this.boobleModalData.numeroDI,
        this.boobleModalData.protocoloDI
      )
      .subscribe((uploadResult) => {
        /*    if (this.boobleModalData.sender.copyInvoiceEmail) {
            this.ordersService
              .sendEmailExistingInvoice(this.boobleModalData.id)
              .subscribe();
          } */
        this.sendButton = false;
        this.loading = false;
        this.modalService.dismiss(null);
        this.modalService.present(
          GenerateInvoiceSuccessModalComponent,
          this.boobleModalData.id
        );
        this.ordersService.updateOrderView();
      });
  }
}
